import { openDB } from "idb";

const openStore = async () => {
  return await openDB("store", 1, {
    upgrade(db) {
      db.createObjectStore("events", {
        autoIncrement: true
      });
    }

  });
};

export const addEvent = async event => {
  const db = await openStore();

  if (db.objectStoreNames.length > 0) {
    const tx = db.transaction(["events"], "readwrite");
    const store = tx.objectStore("events");
    await store.put({
      action: event
    });
    await tx.done;
    db.close();
  }
};

const getAll = async () => {
  const db = await openDB("store");
  const items = await db.transaction(["events"]).objectStore("events").getAll();
  return items;
};

const clearDb = async () => {
  const db = await openDB("store");
  await db.clear("events");
};

const logData = async url => {
  const db = await openDB("store");

  if (db.objectStoreNames.length > 0) {
    const actions = await getAll();

    if (actions.length > 0) {
      const data = actions.map(({
        action
      }) => action);
      const event = {
        actionEvents: data
      };
      const blob = new Blob([JSON.stringify(event, null, 2)], {
        type: "application/json"
      });
      await clearDb();
      navigator.sendBeacon(`${url}/createEvent`, blob);
    }
  }
};

const listener = async url => {
  document.onvisibilitychange = async function () {
    if (document.visibilityState === "hidden") {
      await logData(url);
    }
  };

  setInterval(async function () {
    await logData(url);
  }, 60 * 1000);
};

export const cacheHelper = {
  addEvent,
  getAll,
  listener
};